module.exports = __webpack_public_path__ + "static/media/x.af15c025.svg";